import { Styles } from "@/shared/coralreef";
import { px } from "csx";
import { Horizontal } from "gls/lib";
import { style } from "typestyle";

interface BadgeProps {}

export const Badge: FCWithChildren<BadgeProps> = ({ children }) => {
  return (
    <Horizontal
      padding={5}
      className={style({
        borderRadius: px(12),
        background: Styles.Colours.red,
        fontSize: 12,
        color: Styles.Colours.textDark,
        fontWeight: "bold",
      })}
    >
      {children}
    </Horizontal>
  );
};
